import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './BannerRoleta.module.scss';

export default function BannerRoleta() {
  const navigate = useNavigate();

  return (
    <div className={styles.banner} onClick={() => navigate('/roleta')}>
      <div className={styles.esquerda}>
        <span className={styles.icone}>🎡</span>
      </div>

      <div className={styles.centro}>
        <p className={styles.chamada}>NOVIDADE!</p>
        <h2 className={styles.titulo}>Roleta da Sorte</h2>
        <p className={styles.subtitulo}>
          Compre bolões e ganhe giros para sortear cotas grátis!
        </p>
      </div>

      <div className={styles.direita}>
        <button className={styles.btn}>
          Girar agora
          <span className={styles.seta}>→</span>
        </button>
      </div>
    </div>
  );
}
